import { c } from "react-compiler-runtime";
import { useGraphiQL, useMonaco } from "@graphiql/react";
import { parse } from "graphql";
import { useState, useEffect } from "react";
import { cursorContextAtOffset } from "../lib/schema-walk.js";
const EMPTY_CONTEXT = {
  target: void 0,
  path: []
};
function useCursorContext() {
  const $ = c(6);
  const queryEditor = useGraphiQL(_temp);
  const monaco = useMonaco(_temp2);
  const [context, setContext] = useState(EMPTY_CONTEXT);
  let t0;
  if ($[0] !== (monaco == null ? void 0 : monaco.editor) || $[1] !== queryEditor) {
    t0 = () => {
      if (!queryEditor) {
        return;
      }
      let timer;
      const recompute = () => {
        const model = queryEditor.getModel();
        const pos = queryEditor.getPosition();
        if (!model || !pos) {
          return;
        }
        const offset = model.getOffsetAt(pos);
        let resolved;
        try {
          resolved = cursorContextAtOffset(parse(model.getValue()), offset);
        } catch {
          return;
        }
        setContext(resolved ?? EMPTY_CONTEXT);
      };
      const schedule = () => {
        clearTimeout(timer);
        timer = setTimeout(recompute, 80);
      };
      const disposable = queryEditor.onDidChangeCursorPosition((e) => {
        if (e.reason === (monaco == null ? void 0 : monaco.editor.CursorChangeReason.Explicit)) {
          schedule();
        }
      });
      recompute();
      return () => {
        clearTimeout(timer);
        disposable.dispose();
      };
    };
    $[0] = monaco == null ? void 0 : monaco.editor;
    $[1] = queryEditor;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== monaco || $[4] !== queryEditor) {
    t1 = [queryEditor, monaco];
    $[3] = monaco;
    $[4] = queryEditor;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
  return context;
}
function _temp2(state_0) {
  return state_0.monaco;
}
function _temp(state) {
  return state.queryEditor;
}
export {
  useCursorContext
};
//# sourceMappingURL=use-cursor-path.js.map
